import InstallAppPrompt from './InstallAppPrompt'

export default InstallAppPrompt
